import { Link } from "react-router-dom";

import Banner from "components/UI/Banner/Banner";
import Button from "components/UI/Button/Button";

import popupStore from "components/Popup/PopupStore";
import messageBoxStore from "MessageBox/MessageBoxStore";

import dinoModal from 'assets/images/dino/dino-modal.png';
import dinoModalStep2 from 'assets/images/dino/dino-modal-step2.png';
import dinoStep3 from 'assets/images/dino/dino-step3.png';
import dinoStep3Mini from 'assets/images/dino/dino-step3-mini.png';

import "./BannerStep.scss";

const BannerStep = ({
  appStore,
  banner,
  onClick,
  isMobile
}) => {

  const toggleTelegramNotifications = async () => {
    popupStore.open('bot-modal');
    if (!appStore.telegramId) {
      try {
        await appStore.turnOnNotifications();
      } catch (error) {
        messageBoxStore.showError(error || "Произошла ошибка при формировании кода");
      }
    }
  };

  const stepContent = {
    'banner-finish': {
      image: isMobile ? dinoStep3Mini : dinoStep3,
      imagePosition: "left",
      content: (
        <div className="banner-step">
          <p className={`banner-step__title ${banner}`}>Запуск!</p>
          <p className="banner-step__text">Все готово к запуску? Проверь еще раз, все ли верно и <span>жми кнопку «Создать проект»</span></p>
          <Button title="Создать проект" onClick={onClick} />
        </div>
      )
    },
    'banner-modal': {
      image: dinoModal,
      imagePosition: "right",
      content: (
        <div className="banner-step">
          <p className="banner-step__text">Для комфортной работы на платформе, просим <span>внимательно прочитать правила и условия.</span></p>
        </div>
      )
    },
    'banner-modal-step2': {
      image: dinoModalStep2,
      imagePosition: "right",
      content: (
        <div className="banner-step">
          <p className={`banner-step__title ${banner}`}>Обратите внимание!</p>
          <p className="banner-step__text">При нарушении перечисленных выше условий Ваш аккаунт будет <span><i>заблокирован</i></span></p>
        </div>
      )
    },
    'banner-project-left': {
      content: (
        <div className="banner-step">
          <div className="banner-step__subtitle">
            <div className="banner-step__subtitle-icon-left" />
            <p className="banner-step__subtitle-text">Напоминание</p>
          </div>
          <div className="banner-step__description">
            {!isMobile && <p className="banner-step__text">Не забывайте регулярно <span><i>проверять отчеты исполнителей!</i></span></p>}
            {!isMobile && <p className="banner-step__text">Следите за прогрессом и своевременно вносите корректировки.</p>}
            {isMobile && <p className="banner-step__text">Не забывайте регулярно <span><i>проверять отчеты исполнителей!</i></span> Следите за прогрессом и своевременно вносите корректировки.</p>}
          </div>
        </div>
      )
    },
    'banner-project-right': {
      content: (
        <div className="banner-step">
          <div className="banner-step__subtitle">
            <div className="banner-step__subtitle-icon-right" />
            <p className="banner-step__subtitle-text">Уведомление</p>
          </div>
          <div className="banner-step__description">
            <p className="banner-step__text">Для оперативного получения уведомлений о новых отчетах, подключите <i><Link className="banner-step__link" onClick={toggleTelegramNotifications}>Telegram-бота.</Link></i></p>
          </div>        
        </div>
      )
    }
  };
  const currentStep = stepContent[banner];

  if (!currentStep) return null;

  return (
    <Banner
      image={currentStep.image}
      imagePosition={currentStep.imagePosition}
      content={currentStep.content}
      className={banner}
    />
  );
};

export default BannerStep;
